import { render } from "./Registration.vue?vue&type=template&id=4206a934&scoped=true&ts=true"
import script from "./Registration.vue?vue&type=script&lang=ts"
export * from "./Registration.vue?vue&type=script&lang=ts"

import "./Registration.vue?vue&type=style&index=0&id=4206a934&scoped=true&lang=css"
import "./Registration.vue?vue&type=style&index=1&id=4206a934&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4206a934"]])

export default __exports__